/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import React, {
    useCallback, useEffect, useState, useContext
} from 'react';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { ViewModelServiceContext, ViewModelForm, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { useModal } from '@jutro/components';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import {
    BusinessDetailsTableActionComponent,
    LocationTableActionComponent,
    WatercraftOperatorsTableActionComponent,
    WatercraftTableActionComponent,
    UnderlyingPolicyComponent
} from 'ml-capability-quoteandbind-common-react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useValidation } from '@xengage/gw-portals-validation-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { QuestionSetComponent, platformMessages, FormModalPopover } from 'ml-components-platform-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { MLNotificationBlockUtil, MLPupLineValidatorUtil, MLWizardNavUtil } from 'ml-portals-util-react';
import { MLModalService } from 'ml-portals-services-react';
import { MLMultiLobsDataHolderService } from 'ml-services-common-react';
import { QuestionSetsParser } from 'ml-portals-questionsets-js';
import { FormattedMessage, useTranslator } from '@jutro/locale';
import appConfig from 'app-config';
import classNames from 'classnames';
import { MLUWIssuesPanelComponent } from 'gw-capability-gateway-quoteandbind-common-react';
import {LoadSaveService} from "gw-capability-gateway-quoteandbind";
import { MLErrorMessageUtil } from 'ml-portals-util-js';

import { UserService } from 'gw-capability-gateway';
import PUMBTrackEvent from 'gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/PUMBTrackEvent';
import styles from './WatercraftLocationBusinessDetails.module.scss';

import addEditUnderlyingPolicyPopupMetadata from '../UnderlyingPolicies/AddEditUnderlyingPolicyPopup.metadata.json5';
import metadata from './WatercraftLocationBusinessDetails.metadata.json5';
import messages from './WatercraftLocationBusinessDetails.messages';

const WatercraftLocationBusinessDetailsPage = (props) => {
    const modalApi = useModal();
    const viewModelService = useContext(ViewModelServiceContext);
    const {
        wizardData: submissionVM, updateWizardData, goNext, currentStep, isSkipping, steps, history
    } = props;
    const {
        onValidate
    } = useValidation('WatercraftLocationBusinessDetails');
    const { refreshData } = useDataRefresh();
    const translator = useTranslator();
    const { LoadSaveService } = useDependencies('LoadSaveService');

    const {nextStepVisited, canShowReturnToQuoteButton} = MLWizardNavUtil(props);

    const {
        showProgressDialog,
        hideProgressDialog,
        showErrorModal
    } = MLModalService();

    const MLAlertService = MLNotificationBlockUtil();
    const MLPUPLineValidatorUtilInstance = MLPupLineValidatorUtil();

    const {
        clearBlockAlerts,
        addErrorAlert,
        addWarningAlert,
        getNumberOfAlerts,
        clearManyBlockAlertsStartsWith
    } = MLAlertService;

    const { authHeader } = useAuthentication();
    const isGpa = appConfig.portalCode === 'GPA';

    let isInSync = false;
    let nonEditingLocation = [];
    let nonEditingWatercrafts = [];
    let nonEditingBusActivities = [];

    const isModernProduct = _.get(submissionVM, "isModernProduct_Ext.value", false);
    const isPersonalUmbrella = submissionVM.value.isPersonalUmbrella();
    const isUMB_NP = isPersonalUmbrella && isModernProduct;
    const policyAddress = _.get(submissionVM, 'baseData.policyAddress');
    const pupModel = _.get(submissionVM, 'lobData.personalUmbrella');
    const locationModel = _.get(submissionVM, 'lobData.value.personalUmbrella.coverables.locations');
    const watercraftOperatorsModel = _.get(submissionVM, 'lobData.value.personalUmbrella.coverables.watercraftOperators');
    const watercraftsModel = _.get(submissionVM, 'lobData.value.personalUmbrella.coverables.watercrafts');
    const businessActivitiesModel = _.get(submissionVM, 'lobData.value.personalUmbrella.coverables.businessActivities');
    
    
    const watercraftExposures = pupModel.coverables.watercrafts;
    let watercraftQuestionSet = [];
    const [areThereInvalidExposures, updateAreThereInvalidExposures] = useState({
        areThereInvalidBusinessActivities: false,
        areThereInvalidLocations: false,
        areThereInvalidWatercrafts: false
    });
    const [clickedOnNext, updateClickedOnNext] = useState(false);
    const [questionSetsMetadata, setQuestionSetsMetadata] = useState(null);
    const [showReturnToQuote, setShowReturnToQuote] = useState(false);
    const quoteStep = steps.find((step) => step.mlStepName === 'quoteDetails');
    const [canRequote, setCanRequote] = useState(false);
    const [showValidationErrors, setShowValidationErrors] = useState(false);
    const [isStepActionModalOpen, setIsStepActionModalOpen] = useState();
    const [stepActionData, setStepActionData] = useState();
    const [isUWIssuesPanelVisible, setIsUWIssuesPanelVisible] = useState(false);
    const [blockingUwIssues, setBlockingUwIssues] = useState([]);
    const [disableNextButton, setDisableNextButton] = useState(false);

    if (pupModel.coverables.watercrafts.value.length > 0) {
        watercraftQuestionSet = watercraftExposures.value[0].watercraftQuestionSet || [];
    }

    const buildObjectRepresentations = (value, errorString) => {
        return {
            isInvalid: value,
            errorString: errorString
        };
    };

    const createErrorMessage = (contentOfError) => {
        const alertName = `needsAttention${contentOfError}`;
        clearBlockAlerts(alertName);
        addErrorAlert({...messages.exposureError, args: { item: contentOfError}}, alertName);
    };

    const fillErrorBarBasedOnInvalidExposures = () => {
        const invalidExposures = [
            buildObjectRepresentations(areThereInvalidExposures.areThereInvalidBusinessActivities, 'Business Activities'),
            buildObjectRepresentations(areThereInvalidExposures.areThereInvalidLocations, 'Locations'),
            buildObjectRepresentations(areThereInvalidExposures.areThereInvalidWatercrafts, 'Watercrafts')
        ].filter((exposure) => (exposure.isInvalid === true));

        switch (invalidExposures.length) {
            case 3:
                createErrorMessage(`${invalidExposures[0].errorString},
                                          ${invalidExposures[1].errorString}
                                         and ${invalidExposures[2].errorString}`);
                break;
            case 2:
                createErrorMessage(`${invalidExposures[0].errorString} and ${invalidExposures[1].errorString}`);
                break;
            case 1:
                createErrorMessage(`${invalidExposures[0].errorString}`);
                break;
            default:
                break;
        }
    };

    const shouldShowErrorBar = () => {
        const errorBar = areThereInvalidExposures.areThereInvalidBusinessActivities
        || areThereInvalidExposures.areThereInvalidWatercrafts
        || areThereInvalidExposures.areThereInvalidLocations;
        return errorBar;
    };

    const setCanRequoteFlag = useCallback ( async() => {
        setCanRequote(showReturnToQuote && _.get(quoteStep, 'visited') !== true);
    }, [quoteStep, showReturnToQuote]);

    useEffect(() => {
        if (isGpa && !isSkipping) {
            UserService.getCurrentUser(authHeader).then((user) => {
                PUMBTrackEvent('Quote Step Reached', isSkipping, submissionVM, user, { step: 'Property Exposure Page' });
            });
        }
        canShowReturnToQuoteButton(submissionVM, authHeader, quoteStep).then((response) => {
            setShowReturnToQuote(!!response);
        });
        checkForQuestionUwIssues();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        setCanRequoteFlag();
    }, [setCanRequoteFlag, submissionVM]);

    useEffect(() => {
        const errorBar = shouldShowErrorBar();
        if (errorBar) {
            fillErrorBarBasedOnInvalidExposures();
        } else {
            clearManyBlockAlertsStartsWith("needsAttention");
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [areThereInvalidExposures]);

    useEffect(() => {
        if (isStepActionModalOpen) {
            _.set(submissionVM, 'value.wizardActionDataML', {});
            setStepActionData(null);
        }
    }, [isStepActionModalOpen]);

    useEffect(() => {
        const stepDataML = _.get(submissionVM, 'value.wizardActionDataML', {});
        if (!_.isEmpty(stepDataML)) {
            setStepActionData(stepDataML);
        }
    }, []);

    const onQuestionSetValueChange = (aQuestionSetAnswersValue) => {
        _.set(submissionVM, 'lobData.personalUmbrella.coverables.watercrafts.value[0].watercraftQuestionSet[0]', aQuestionSetAnswersValue);
        setDisableNextButton(false);
        updateWizardData(submissionVM);
    }

    const checkForQuestionUwIssues = useCallback(() => {
        const uwIssues = submissionVM.errorsAndWarnings?.underwritingIssues?.value ? 
                        submissionVM.errorsAndWarnings?.underwritingIssues?.value :
                        submissionVM.value.uwIssues_ML;

        if (uwIssues?.length > 0) {
            const questionCheckpointIssues = uwIssues.filter((issue) => {
                return (issue.checkingSet_Ext === 'location_exposure_ml'  || issue.checkingSet_Ext === 'watercraft_exposure_ml') && issue.currentBlockingPoint === 'BlocksQuote'
                ||issue.checkingSet_Ext === 'liability_coverage_ml' && issue.currentBlockingPoint === 'BlocksQuote';
            });

            if (questionCheckpointIssues?.length > 0) {
                setIsUWIssuesPanelVisible(true);
                setBlockingUwIssues(questionCheckpointIssues);
                setDisableNextButton(true);
                return true;
            }
            setDisableNextButton(false);
            return false;
        }
        return false;
    }, [submissionVM?.uwIssues_ML?.value]);

    const checkForDisableNextButton = useCallback((issues) => {
        if (issues?.length > 0) {
            const questionCheckpointIssues = issues.filter((issue) => {
                return (issue.checkingSet_Ext === 'location_exposure_ml' || issue.checkingSet_Ext === 'watercraft_exposure_ml')  && issue.currentBlockingPoint === 'BlocksQuote';
            });
            setDisableNextButton(questionCheckpointIssues?.length > 0);
        }
    }, []);

    const handleULPolicyAlerts = useCallback((warningMissingExposureMessages) => {
        const ALERT_BLOCK_UL_POLICY = 'ALERT_BLOCK_UL_POLICY';
        clearBlockAlerts(ALERT_BLOCK_UL_POLICY);
        warningMissingExposureMessages.forEach((message) => addErrorAlert(message, ALERT_BLOCK_UL_POLICY));
    }, [addErrorAlert, clearBlockAlerts]);

    const validateULPolicy = useCallback(() => {
        if (clickedOnNext) {
            const warningMissingExposureMessages = MLPUPLineValidatorUtilInstance.validateWatercraftLocationBusinessDetailsExposures(pupModel);
            handleULPolicyAlerts(warningMissingExposureMessages);
        }
    }, [MLPUPLineValidatorUtilInstance, clickedOnNext, handleULPolicyAlerts, pupModel]);

    const getQuestionSetMetadata = useCallback(async () => {
        const questionsMetadata = await import(
            /* webpackChunkName: "question-sets-metadata" */
            // eslint-disable-next-line import/no-unresolved
            'question-sets-metadata'
        ).then((data) => {
            const { default: result } = data;
            setQuestionSetsMetadata(result);
            return result;
        });

        return questionsMetadata;
    }, []);

    const getQuestionSetViewModel = useCallback(async (questionSet) => {
        let qs = questionSetsMetadata;
        if(qs === null || qs === undefined) {
            qs = await getQuestionSetMetadata();
        }
        const { viewModel: qsViewModel } = new QuestionSetsParser(questionSet, qs, translator);
        return qsViewModel;
    }, [questionSetsMetadata, translator]);

    const checkForQuestionSetErrors = useCallback(async(questionSet) => {
        const qsViewModel =  await getQuestionSetViewModel(questionSet);
        const  showError = !!qsViewModel.answers && Object.keys(qsViewModel.answers).some((ansKey) => !_.isUndefined(qsViewModel[ansKey]) && !qsViewModel[ansKey].aspects.valid);
        
        setShowValidationErrors(showError);
        return showError
    }, [getQuestionSetViewModel]);


    const showAnimalExclusionWarningMessage = (shouldShow) => {
        const messageName = 'PUPLocationAnimalExclusionWarning';
        if (shouldShow) {
            if (getNumberOfAlerts('PUPLocationAnimalExclusionWarning') <= 0) {
                addWarningAlert(messages.animalExclusionError, messageName);
            }
        } else if (getNumberOfAlerts('PUPLocationAnimalExclusionWarning') > 0) {
            clearBlockAlerts(messageName);
        }
    };

    // showAnimalExclusionWarningMessage(pupModel.coverables.locations.value
    //    .some((location) => location.locationQuestionSet.shouldDispalyAnimalExclusionWarning_ML));

    const setLocationExposureRequiredFields = () => {
        const locations = pupModel.coverables.locations.value;
        if (locations && locations.length > 0) {
            locations.forEach((loc) => {
                loc.isDwellingUsageRequired_ML = true;
                loc.isDwellingOccupancyRequired_ML = true;
            });
        }
    };

    const initWatercraftOperator = (watercraftOperatorVM) => {
        watercraftOperatorVM.isYearsOfExperienceRequired.value = true;
        return watercraftOperatorVM;
    };
    
    const removeValidationWatercraftOperator = (watercraftOperatorVM) => {
        watercraftOperatorVM.isYearsOfExperienceRequired.value = false;
        return watercraftOperatorVM;
    };

    // =========== Error Bar Logic =========== //

    const invalidExposures = (exposures, exposureDTOReference) => {
        let returnValue = false;
        if (exposures.length > 0) {
            exposures.value.forEach((exposure) => {
                const exposureVM = viewModelService.create(exposure, 'pc', exposureDTOReference);
                if (!exposureVM.aspects.valid || !exposureVM.aspects.subtreeValid) {
                    exposure.error = true;
                    returnValue = true;
                } else {
                    exposure.error = false;
                }
            });
        }
        return returnValue;
    };

    const areLocationsQuestionSetsValid = async (locations) => {
        for (const location of locations) {
            if (location.locationQuestionSet?.questionSets) {
                for (const locationQS of location.locationQuestionSet.questionSets) {
                    if(location?.locationType !== "VacantLand" ){
                        const isValidQuestions = await checkForQuestionSetErrors(locationQS);
                        if (isValidQuestions) {
                            location.error = true;
                            break;
                        }
                    }
                }
            }
        }

        const result = locations.some((location) => location.error);

        return result;
    };

    const setInvalidExposureChecks = async () => {
        const locationsLength = pupModel.coverables.locations.value.length;
        const watercraftsLength = pupModel.coverables.watercrafts.value.length;
        const busActivitiesLength = pupModel.coverables.businessActivities.value.length;

        const _areThereInvalidLocations = locationsLength > 0
            ? invalidExposures(
                pupModel.coverables.locations,
                'metlife.edge.capabilities.common.plugin.dto.PupLocationDTOML')
            : false;

        const exposuresCheck = {};
        const isLocationsQuestionSetsValid =  await areLocationsQuestionSetsValid(pupModel.coverables.locations.value)
        exposuresCheck.areThereInvalidLocations = _areThereInvalidLocations || isLocationsQuestionSetsValid;
        exposuresCheck.areThereInvalidWatercrafts = watercraftsLength > 0
            ? invalidExposures(
                pupModel.coverables.watercrafts,
                'metlife.edge.capabilities.common.plugin.dto.PUPWatercraftDTOML')
            : false;
        exposuresCheck.areThereInvalidBusinessActivities = busActivitiesLength > 0
            ? invalidExposures(
                pupModel.coverables.businessActivities,
                'metlife.edge.capabilities.common.plugin.dto.PUPBusinessActivityDTOML')
            : false;

        updateAreThereInvalidExposures(exposuresCheck);
        refreshData();
        return exposuresCheck;
    };

    const setFixIdsOfNonEditingLocations = (inputSubmissionVM) => {
        nonEditingLocation = [];
        inputSubmissionVM.lobData.personalUmbrella.coverables.locations.value.forEach((location) => {
            if (location.publicID && location.isEditing !== true) {
                nonEditingLocation.push(location.publicID);
            }
        });
    };

    const setFixedIdsOfNonEditingWatercrafts = (inputSubmissionVM) => {
        nonEditingWatercrafts = [];
        inputSubmissionVM.lobData.personalUmbrella.coverables.watercrafts.value.forEach((watercraft) => {
            if (watercraft.publicID && watercraft.isEditing !== true) {
                nonEditingWatercrafts.push(watercraft.publicID);
            }
        });
    };

    const init = () => {
        setLocationExposureRequiredFields();
        setInvalidExposureChecks();
        setFixIdsOfNonEditingLocations(submissionVM);
        setFixedIdsOfNonEditingWatercrafts(submissionVM);
        showAnimalExclusionWarningMessage(pupModel.coverables.locations.value
            .some((location) => _.get(location, 'locationQuestionSet.shouldDispalyAnimalExclusionWarning_ML', false)));
    };

    useEffect(() => {
        getQuestionSetMetadata();
        if(isSkipping && skipOnResumeIf){
            goNext();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (questionSetsMetadata) {
            init();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [questionSetsMetadata]);

    const checkLocationsForInvalidExposures = async () => {
        let areThereInvalidLocations = invalidExposures(
            pupModel.coverables.locations,
            'metlife.edge.capabilities.common.plugin.dto.PupLocationDTOML');
        const isLocationsQuestionSetsValid =  await areLocationsQuestionSetsValid(pupModel.coverables.locations.value);

        areThereInvalidLocations = areThereInvalidLocations || isLocationsQuestionSetsValid;
        updateAreThereInvalidExposures({...areThereInvalidExposures, areThereInvalidLocations});
    };

    const checkWatercraftsForInvalidExposures = () => {
        const areThereInvalidWatercrafts = invalidExposures(
            pupModel.coverables.watercrafts,
            'metlife.edge.capabilities.common.plugin.dto.PUPWatercraftDTOML');
        updateAreThereInvalidExposures({...areThereInvalidExposures, areThereInvalidWatercrafts});
        refreshData();
    };

    const checkBusinessActivitiesForInvalidExposures = () => {
        const areThereInvalidBusinessActivities = invalidExposures(
            pupModel.coverables.businessActivities,
            'metlife.edge.capabilities.common.plugin.dto.PUPBusinessActivityDTOML');
        updateAreThereInvalidExposures({...areThereInvalidExposures, areThereInvalidBusinessActivities});
        refreshData();
    };

    // =========== Error Bar Logic =========== //

    const setFixIdsOfNonEditingBusActivities = (inputSubmissionVM) => {
        nonEditingBusActivities = [];
        inputSubmissionVM.lobData.personalUmbrella.coverables.businessActivities.value.forEach((busActivity) => {
            if (busActivity.publicID && !busActivity.isSelected && busActivity.isEditing !== true) {
                nonEditingBusActivities.push(busActivity.publicID);
            }
        });
    };


    // =========== Underlying Policy =========== //
    const primaryNamedInsured = submissionVM.value.getPrimaryNamedInsured();
    const PRIMARY_NAMED_INSURED = 'primary_named_insured';
    const SECONDARY_NAMED_INSURED = 'secondary_named_insured';
    const OTHER_INSURED = 'other';

    const getFirstNamedInsuredRole = () => {
        let retObj = {};
        if (primaryNamedInsured) {
            retObj = {
                role: PRIMARY_NAMED_INSURED,
                displayName: primaryNamedInsured.displayName
            };
        }
        return retObj;
    };

    const getSecondaryNamedInsuredDisplayName = () => {
        const secondaryNamedInsured = _.get(submissionVM, 'baseData.secondaryNamedInsured_ML.value');
        let displayName = '';
        if (secondaryNamedInsured) {
            displayName = `${secondaryNamedInsured.firstName} ${secondaryNamedInsured.middleName} ${secondaryNamedInsured.lastName}`;
        }
        return displayName;
    };

    const getSecondaryNamedInsuredRole = () => {
        const secondaryNamedInsured = _.get(submissionVM, 'baseData.secondaryNamedInsured_ML.value');
        let retObj = {};
        if (secondaryNamedInsured) {
            retObj = {
                role: SECONDARY_NAMED_INSURED,
                displayName: getSecondaryNamedInsuredDisplayName()
            };
        }
        return retObj;
    };

    const hasSecondaryNamedInsured = () => {
        const secondaryNamedInsured = _.get(submissionVM, 'baseData.secondaryNamedInsured_ML.value');
        return !!secondaryNamedInsured;
    };

    const initNamedInsureds = () => {
        const insureds = [];
        const other = {
            role: OTHER_INSURED,
            displayName: 'Other'
        };

        insureds.push(getFirstNamedInsuredRole());
        if (hasSecondaryNamedInsured()) {
            insureds.push(getSecondaryNamedInsuredRole());
        }

        insureds.push(other);
        return insureds;
    };

    const addUnderlyingPolicy = (ulPolicy) => {
        if (ulPolicy.aspects.valid && ulPolicy.aspects.subtreeValid) {
            let currentExposure;

            const {exposureType} = ulPolicy.value;

            switch (exposureType) {
                case 'watercraft':
                    currentExposure = pupModel.coverables.watercrafts.children.find((wc) => {
                        return wc.value.isEditing === true;
                    });
                    break;
                case 'location':
                    currentExposure = pupModel.coverables.locations.children.find((loc) => {
                        return loc.value.isEditing === true;
                    });
                    break;
                case 'business':
                    currentExposure = pupModel.coverables.businessActivities.children.find((ba) => {
                        return ba.value.isEditing === true;
                    });
                    break;
                default:
                    currentExposure = undefined;
                    break;
            }

            if (currentExposure) {
                currentExposure.ulPolicyFixID.value = ulPolicy.ulPolicyFixID.value;
                setInvalidExposureChecks();
                validateULPolicy();
                return true;
            }
        }
        return false;
    };

    const cancelAddUnderlyingPolicy = (ulPolicy) => {
        pupModel.value.removeUnderlyingPolicy(ulPolicy.value);
        setInvalidExposureChecks();
        validateULPolicy();
        refreshData();
    };

    const getModalTitle = () => {
        return messages.addAPolicy;
    };

    const getAddButtonLabel = () => {
        return messages.addPolicy;
    };

    const getCancelButtonLabel = () => {
        return messages.cancel;
    };

    const openULModal = (data) => {
        const componentProps = {
            title: getModalTitle(),
            viewModel: data.ulPolicy,
            uiProps: addEditUnderlyingPolicyPopupMetadata.pageContent,
            actionBtnLabel: getAddButtonLabel(),
            cancelBtnLabel: getCancelButtonLabel(),
            getOverrideProps: () => {
                return {
                    underlyingPolicyComponent: {
                        underlyingPolicyVM: data.ulPolicy,
                        sessionUUID: submissionVM.value.sessionUUID,
                        quoteID: submissionVM.value.quoteID,
                        isEdit: false,
                        authHeader,
                        isComponent: true,
                        MLAlertService,
                        isModernProduct
                    }
                };
            },
            onSaveAction: addUnderlyingPolicy,
            customComponentResolvers: {
                underlyingPolicyComponent: UnderlyingPolicyComponent
            }
        };


        return modalApi.showModal(
            <FormModalPopover {...componentProps} />
        ).catch(() => cancelAddUnderlyingPolicy(data.ulPolicy));
    };

    const createNewULPolicy = (exposureType) => {
        const newUnderlyingPolicy = pupModel.value.createUnderlyingPolicy();
        const ulPolicy = submissionVM.lobData.personalUmbrella.underlyingPolicies.findFirstElement(newUnderlyingPolicy);
        /* const index = pupModel.underlyingPolicies.value.findIndex((ulPolicy) => ulPolicy.ulPolicyFixID === 'new');
        const ulPolicy = pupModel.underlyingPolicies.getElement(index); */
        ulPolicy.value.exposureType = exposureType;

        const data = {
            ulPolicy,
            quoteID: submissionVM.value.quoteID,
            namedInsureds: initNamedInsureds(),
            sessionID: submissionVM.value.sessionUUID,
            exposureType: exposureType
        };

        return openULModal(data);
    };

    const getUnderlyingPolicies = () => {
        let addedPolicy;
        if (isInSync === false) {
            if (pupModel.underlyingPolicies.value.findIndex((ulPolicy) => ulPolicy.ulPolicyFixID === 'new') === -1) {
                addedPolicy = pupModel.value.createUnderlyingPolicy({
                    ulPolicyFixID: 'new',
                    policyNumber: translator(messages.underlyingPolicyNotListed)
                });
            }
        }

        const mappedValues = pupModel.underlyingPolicies.value.map((policy) => {
            let underlyingPolicyDisplayName = policy.getDisplayName(viewModelService.productMetadata, translator);
            if(isUMB_NP && policy.policyType === 'HO') {
                underlyingPolicyDisplayName = underlyingPolicyDisplayName.replace('Homeowners', 'Property');
            }
            return {
                code: policy.ulPolicyFixID,
                name: underlyingPolicyDisplayName
            };
        });

        if (addedPolicy !== undefined) {
            pupModel.value.removeUnderlyingPolicy(addedPolicy);
        }
        return mappedValues;
    };
    // =========== Underlying Policy =========== //

    const syncExposure = () => {
        isInSync = true;
        return LoadSaveService.updateDraftSubmission(submissionVM.value, authHeader).then((updatedSubmissionData) => {
            _.set(submissionVM, 'value', updatedSubmissionData);
            isInSync = false;
            return submissionVM;
        });
    };

    const syncBusActivityExposure = (businessActivityExposureID) => {
        setFixIdsOfNonEditingBusActivities(submissionVM);

        return syncExposure().then((updatedSubmissionVM) => {
            let index = 0;

            if (nonEditingBusActivities.length > 0) {
                index = updatedSubmissionVM.lobData.personalUmbrella.coverables.businessActivities.value.findIndex((busActivity) => nonEditingBusActivities.indexOf(busActivity.publicID) === -1);
            }
            if (index === -1 && businessActivityExposureID) {
                index = updatedSubmissionVM.lobData.personalUmbrella.coverables.businessActivities.value.findIndex((busActivity) => busActivity.publicID === businessActivityExposureID);
            }

            return updatedSubmissionVM.lobData.personalUmbrella.coverables.businessActivities.getElement(index);
        });
    };

    const syncLocation = () => {
        setFixIdsOfNonEditingLocations(submissionVM);
        return syncExposure().then((updatedSubmissionVM) => {
            const index = updatedSubmissionVM.lobData.personalUmbrella.coverables.locations.value.findIndex((location) => nonEditingLocation.indexOf(location.publicID) === -1);
            return updatedSubmissionVM.lobData.personalUmbrella.coverables.locations.getElement(index);
        });
    };

    const syncWatercraft = () => {
        setFixedIdsOfNonEditingWatercrafts(submissionVM);
        var isOperatorPresent = pupModel.coverables.watercraftOperators.value.length > 0
        return syncExposure().then((updatedSubmissionVM) => {
            let index = 0;
            if (nonEditingWatercrafts.length > 0) {
                index = updatedSubmissionVM.lobData.personalUmbrella.coverables.watercrafts.value.findIndex((watercraft) => nonEditingWatercrafts.indexOf(watercraft.publicID) === -1);
            }
            // eslint-disable-next-line prefer-destructuring
            watercraftQuestionSet = updatedSubmissionVM.lobData.personalUmbrella.coverables.watercrafts.getElement(index).value.watercraftQuestionSet;
            return updatedSubmissionVM.lobData.personalUmbrella.coverables.watercrafts.getElement(index);
        });
    };

    // ctrl.goToNext = (nextFn) => {
    //     ctrl.manuallyValidateQuestions();
    //     const errorMessages = MLPUPLineValidatorUtil.validateWatercraftLocationBusinessDetailsExposures($scope.pupModel.value);
    //     if (errorMessages.length > 0) {
    //         ctrl.setAndGoToExposureWarning(errorMessages);
    //         ctrl.setValidationWatchesOnNext();
    //         return;
    //     }
    //     if (!ctrl._areWatercraftQuestionsValid()) {
    //         return;
    //     }
    //     submissionVM.value.beforeSave();
    //     nextFn(submissionVM);
    // };

    // =========== Table Functions =========== //

    const emptyWatercraftQuestionSet = () => {
        watercraftQuestionSet = [];
    };

    const displayWatercraftQuestionSet = () => {
        if (isModernProduct) {
            return false;
        }
        if (pupModel.coverables.watercrafts.value) {
            return pupModel.coverables.watercrafts.value.length > 0;
        }
        return false;
    };

    const areWatercraftQuestionsValid = useCallback(async() => {
        if(watercraftQuestionSet && !_.isEmpty(watercraftQuestionSet)){
           const isValidQuestions =  await checkForQuestionSetErrors(watercraftQuestionSet)
           return !isValidQuestions
        }

        return true
        
    },[checkForQuestionSetErrors, watercraftQuestionSet])

    const nextStepText = () => {
        return <FormattedMessage
            {...messages.weWillReviewYourQuoteNext}
            values={{
                reviewYourQuote: (
                    <strong>{translator(messages.reviewYourQuote)}</strong>
                )
            }}
        />;
    };

    const validateData = useCallback(async(isReturnToQuote = false) => {
        _.set(submissionVM, 'portalCurrentStep_ML.value', 'pupWatercraftLocationBusinessDetails');

        const errorMessages = MLPUPLineValidatorUtilInstance.validateWatercraftLocationBusinessDetailsExposures(pupModel);
        if (errorMessages.length > 0) {
            handleULPolicyAlerts(errorMessages);
            updateClickedOnNext(true);
            window.scrollTo(0,0);
            return false;
        }
        updateWizardData()
        if(questionSetsMetadata === null || questionSetsMetadata === undefined) {
            await getQuestionSetMetadata();
        }

        const isValid = await areWatercraftQuestionsValid();

        if (!isUMB_NP && !isValid) {
            document.getElementById("questionSetGridId").scrollIntoView({ behavior: 'smooth'})
            
            return false;
        }
        submissionVM.value.beforeSave && submissionVM.value.beforeSave();

        if (isReturnToQuote) {
            if (!submissionVM.aspects.valid || !submissionVM.aspects.subtreeValid) {
                return false;
            }
            MLMultiLobsDataHolderService.storeFlowSteps(currentStep.mlStepName, 'quoteDetails', authHeader);
        }

        return true;
    }, [MLPUPLineValidatorUtilInstance, areWatercraftQuestionsValid, authHeader, currentStep.mlStepName, handleULPolicyAlerts, pupModel, submissionVM, questionSetsMetadata]);

    const onNext = useCallback(async() => {
        if (isGpa) {
            UserService.getCurrentUser(authHeader).then((user) => {
                PUMBTrackEvent('Quote Step Submitted', false, submissionVM, user, { step: 'Property Exposure Page', action: 'Property Exposure Submitted'});
            });
        }

        pupModel.coverables.watercraftOperators.forEach((watercraftOperatorVM) => initWatercraftOperator(watercraftOperatorVM));
        
        if(!pupModel.coverables.watercraftOperators.aspects.subtreeValid){
            const errName = 'watercraftExposuresYearOfExpError'
            clearBlockAlerts(errName);
            addErrorAlert(messages.watercraftExposuresYearOfExpError, errName)
            pupModel.coverables.watercraftOperators.forEach((watercraftOperatorVM) => removeValidationWatercraftOperator(watercraftOperatorVM));
            return false;
        }
            

        if (!submissionVM.value.isQuoted()) {
            _.unset(submissionVM.value, 'bindData');
        }
        
        const isDataValid = await validateData();
        if (!isDataValid) {
            return false;
        }

        if (!submissionVM.aspects.valid || !submissionVM.aspects.subtreeValid) {
            return false;
        }

        showProgressDialog(platformMessages.saveSubmission);
        try {

            const canSkipSave = steps.some((step) => step.mlStepName === 'pupDisclosureToQuote' && !!step.visited);
            if (!canSkipSave) {
                const res = await LoadSaveService.updateDraftSubmission(submissionVM.value, authHeader);
                submissionVM.value = res;
                updateWizardData(submissionVM);
            }
            if (checkForQuestionUwIssues()) {
                return false;
            }
            MLMultiLobsDataHolderService.storeFlowSteps(currentStep.mlStepName, 'pupDisclosureToQuote', authHeader);
            if (nextStepVisited()) {
                goNext();
            }
            return submissionVM;
        } catch (error) {
            MLErrorMessageUtil.handleException(error, showErrorModal, messages.somethingWentWrong);
        } finally {
            hideProgressDialog(platformMessages.saveSubmission);
        }
    }, [isGpa, submissionVM, validateData, authHeader, showProgressDialog, steps, currentStep.mlStepName, nextStepVisited, LoadSaveService, goNext, hideProgressDialog, MLErrorMessageUtil]);

    const overrides = {
        pageHeader: {
            visible: !isGpa,
            content: translator(messages.pageHeader)
        },
        pageContainer: {
            className: isGpa ? classNames("page-content-gpa", styles.peStyles) : undefined
        },
        watercraftTableComponent: {
            submissionVM,
            updateWizardData,
            syncWatercraft,
            watercraftQuestionSet,
            emptyWatercraftQuestionSet,
            getUnderlyingPolicies,
            createUnderlyingPolicy: createNewULPolicy,
            validateAllWatercrafts: checkWatercraftsForInvalidExposures,
            validateULPolicy,
            viewModelService,
            setDisableNextButton
        },
        watercraftQuestionset: {
            visible: displayWatercraftQuestionSet() && watercraftQuestionSet.length > 0,
            onValueChange: onQuestionSetValueChange
        },
        watercraftOperatorsTableComponent: {
            submissionVM,
            updateWizardData,
            validateULPolicy,
            viewModelService,
            syncExposure,
            setDisableNextButton
        },
        locationTableComponent: {
            submissionVM,
            updateWizardData,
            showAnimalExclusionWarningMessage,
            getUnderlyingPolicies,
            onValidate,
            syncExposure: syncLocation,
            createUnderlyingPolicy: createNewULPolicy,
            validateAllLocations: checkLocationsForInvalidExposures,
            policyAddress,
            validateULPolicy,
            setIsStepActionModalOpen,
            stepActionData,
            setDisableNextButton
        },
        businessDetailsTableComponent: {
            submissionVM,
            updateWizardData,
            getUnderlyingPolicies,
            onValidate,
            syncExposure: syncBusActivityExposure,
            createUnderlyingPolicy: createNewULPolicy,
            validateBusinessActivities: checkBusinessActivitiesForInvalidExposures,
            validateULPolicy,
            viewModelService,
            setIsStepActionModalOpen,
            stepActionData,
            setDisableNextButton
        },
        nextButton: {
            // TODO: currently, componenet is invalid due to binding data, so button is disabled all the time.
            disabled: disableNextButton
        },
        nextDescription: {
            content: nextStepText()
        },
        returnToQuoteButton: {
            visible: showReturnToQuote,
            disabled: true
        },
        uwIssueContainer: {
            visible: isUWIssuesPanelVisible,
            uwIssues: blockingUwIssues,
            jobID: submissionVM.value.quoteID,
            publicID: _.get(submissionVM, 'value.publicID'),
            afterIssuesRefreshedCallback: checkForDisableNextButton,
        }
    };
    const resolvers = {
        resolveComponentMap: {
            questionset: QuestionSetComponent,
            watercrafttablecomponent: WatercraftTableActionComponent,
            watercraftoperatorstablecomponent: WatercraftOperatorsTableActionComponent,
            locationtablecomponent: LocationTableActionComponent,
            businessdetailstablecomponent: BusinessDetailsTableActionComponent,
            mluwissuespanelcomponent: MLUWIssuesPanelComponent
        },
        resolveCallbackMap: {
            onValidate: onValidate,
            onNext: onNext,
            getUnderlyingPolicies: getUnderlyingPolicies
        }
    };

    const skipOnResumeIf = async () => {
        if (!!_.get(submissionVM, 'bindData.policyNumber.value')
            && (submissionVM.value.baseData.status_ML === 'Bound' || submissionVM.value.baseData.status_ML === 'Binding')) {
            return true;
        }

        if (MLMultiLobsDataHolderService.getLastVisitedStep() === currentStep.mlStepName) {
            return false;
        }

        const isDataValid = await validateData();
        if (!isDataValid) {
            return false;
        }

        return true;
    };

    return (
        <WizardPage
            showPrevious={false}
            showCancel={false}
            skipWhen={skipOnResumeIf}
            showNext={!nextStepVisited()}
            onNext={onNext}
            disableNext={disableNextButton}
            nextLabel={translator(platformMessages.mlContinue)}
            showTextNextToButton={!nextStepVisited()}
            textNextToButton={nextStepText()}
            metadataPageId={!nextStepVisited() && _.get(metadata, 'pageContent.id')}
            showReturnToQuote={showReturnToQuote && canRequote}
            disableReturnToQuote={!canRequote || disableNextButton}
            updateWizardData={updateWizardData}
            validateData={validateData}
            history={history}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                overrideProps={overrides}
                model={submissionVM}
                componentMap={resolvers.resolveComponentMap}
                onModelChange={updateWizardData}
                callbackMap={resolvers.resolveCallbackMap}
                onValidationChange={onValidate}
                classNameMap={styles}
                showErrors={showValidationErrors}
            />
        </WizardPage>
    );
};

WatercraftLocationBusinessDetailsPage.propTypes = wizardProps;
export default withRouter(WatercraftLocationBusinessDetailsPage);
